import React, { Fragment } from 'react'
import { Link } from 'react-router'
import invariant from 'tiny-invariant'
import * as styles from './breadcrumb.css'

export type BreadcrumbProps = {
  items: { label: string; to: string }[]
  navAriaLabel?: string
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, navAriaLabel }) => {
  invariant(items.length >= 2, 'Breadcrumb must have at least two items')

  const otherItems = items.slice(0, items.length - 1)
  const lastItem = items[items.length - 1]

  invariant(lastItem, 'Last item must be defined')

  return (
    <nav aria-label={navAriaLabel} className={styles.breadcrumbNav}>
      {otherItems.map(item => (
        <Fragment key={item.label}>
          <Link to={item.to} className={styles.breadcrumbLink}>
            {item.label}
          </Link>
          <span className={styles.breadcrumbSeparator}>/</span>
        </Fragment>
      ))}
      <span className={styles.breadcrumbCurrent}>{lastItem.label}</span>
    </nav>
  )
}
